/**
 * Знак «Кличат Плюс»: пузырь с золотым плюсом (docs/brand/plus, выгрузка export.py). Картинка с srcset:
 * браузер сам берёт размер под сторону и плотность экрана. label = null — знак рядом с текстом про Плюс,
 * читалке экрана его не озвучиваем.
 */
export function PlusMark({ size, className, label = 'Кличат Плюс' }: { size: number; className?: string | undefined; label?: string | null }) {
  return (
    <img
      className={className}
      src="/brand/plus-64.webp"
      srcSet="/brand/plus-32.webp 32w, /brand/plus-64.webp 64w, /brand/plus-128.webp 128w, /brand/plus-256.webp 256w"
      sizes={`${size}px`}
      width={size}
      height={size}
      alt={label ?? ''}
      data-tooltip={label ?? undefined}
      aria-hidden={label ? undefined : true}
      draggable={false}
    />
  )
}
